import { render, staticRenderFns } from "./AddProductTable.vue?vue&type=template&id=3a55d5b4"
import script from "./AddProductTable.vue?vue&type=script&lang=js"
export * from "./AddProductTable.vue?vue&type=script&lang=js"
import style0 from "./AddProductTable.vue?vue&type=style&index=0&id=3a55d5b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports